import { DateFormat, formatDate, formatDistanceToNowLang, formatRelativeLang } from "lopermut"
import * as React from "react"
import { Tooltip, TooltipContent, TooltipTrigger } from "../atoms/Tooltip"
import { CONSTANTS } from "../lib/constants"
import { cn } from "../utils"

export type DateDisplayProps = {
  date: string
  format?: "relative" | "absolute" | "distance"
  addSuffix?: boolean
  dateFormat?: DateFormat
  prefix?: string
  onlyDate?: boolean
}

const DateDisplay: React.FC<DateDisplayProps> = ({
  date,
  format = "distance",
  addSuffix = true,
  dateFormat = "Pp",
  prefix,
  onlyDate,
}) => {
  const isLessThanAMonth = React.useMemo(() => {
    const dateObj = new Date(date)
    const oneMonthAgo = new Date()

    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1)
    return dateObj > oneMonthAgo
  }, [date])

  const formattedDate = React.useMemo(() => formatDate(date, dateFormat), [date, dateFormat])

  const isRelative = format !== "absolute" && isLessThanAMonth
  const formatted =
    format === "distance"
      ? formatDistanceToNowLang(date, { addSuffix })
      : formatRelativeLang(date, new Date())

  if (onlyDate) {
    const formattedWithPrefix = prefix ? `${prefix} ${formatted}` : formatted

    return <span className="capitalize-first first">{formattedWithPrefix}</span>
  }

  if (isRelative) {
    const formattedWithPrefix = prefix ? `${prefix} ${formatted}` : formatted

    return (
      <Tooltip>
        <TooltipTrigger>
          <span className={cn("block capitalize-first first", CONSTANTS.tooltip.underline)}>
            {formattedWithPrefix}
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-[400px]">{formattedDate}</TooltipContent>
      </Tooltip>
    )
  }

  const formattedWithPrefix = prefix ? `${prefix} ${formattedDate}` : formattedDate

  return <span>{formattedWithPrefix}</span>
}

export default DateDisplay
